export default __webpack_public_path__ + "static/media/learnB.2960ff55.jpg";